<template>
  <div class="quality-control-panel">
    <v-card-title>
      {{ item.title }}
    </v-card-title>
    <v-card-text>
      {{ item.description }}
    </v-card-text>
    <v-divider></v-divider>

    <div class="pa-4">
      <!-- Error Counter -->
      <div class="mb-6">
        <h4 class="text-subtitle-1 mb-3">Korjatut virheet</h4>
        <div class="d-flex align-center justify-center">
          <v-btn
            icon
            @click="decrementErrors"
            :disabled="errorCount <= 0"
            color="error"
            class="mr-4"
          >
            <v-icon>mdi-minus</v-icon>
          </v-btn>

          <div class="error-count-display">
            <span class="text-h4 font-weight-bold">{{ errorCount }}</span>
          </div>

          <v-btn
            icon
            @click="incrementErrors"
            color="success"
            class="ml-4"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </div>
      </div>

      <!-- Notes Text Box -->
      <div>
        <h4 class="text-subtitle-1 mb-3">Huomioita</h4>
        <v-textarea
          ref="text"
          v-prevent-keys
          v-model="notes"
          outlined
          rows="6"
          placeholder="Jotain huomioita eventeistä?"
          auto-grow
          hide-details
        ></v-textarea>
      </div>

      <!-- Saving indicator -->
      <div style="height: 30px;" class="mt-4">
        <div v-if="saving" class="text-center">
          <span class="ml-2 text-caption">Tallennetaan...</span>
        </div>
      </div>

      <div style="font-size: 12px; color: #666;" class="mt-4">
        Tämän paneelin data päivittyy automaattisesti tietokantaan.
      </div>
    </div>
  </div>
</template>

<script>
import ax from '@/utils/axios/axios.js'
import { mapGetters } from 'vuex'

export default {
  name: 'QualityControlPanel',
  shortcuts: {
    v: function() {
      this.incrementErrors()
    },
    e: function() {
      this.incrementErrors()
    },
    f: function() {
      this.incrementErrors()
    },
    c: function() {
      this.$refs.text.focus()
    },
    esc: function() {
      this.$refs.text.blur()
    },
    shift_v: function() {
      this.decrementErrors()
    }
  },
  props: {
    // Add props as needed
  },
  data() {
    return {
      errorCount: 0,
      notes: '',
      loading: false,
      saving: false,
      saveTimeout: null
    }
  },
  computed: {
    ...mapGetters('user', ['user']),
    result() {
      return JSON.parse(this.$route.query.result);
    },
    item() {
      return JSON.parse(this.$route.query.item);
    },
    resultId() {
      return JSON.parse(this.$route.query.result).id;
    }
  },
  watch: {
    errorCount() {
      this.debouncedSave()
    },
    notes() {
      this.debouncedSave()
    },
    result: {
      immediate: true,
      handler(newResult) {
        if (newResult) {
          this.resultId = newResult
          this.loadResult()
        }
      }
    }
  },
  methods: {
    incrementErrors() {
      this.errorCount++
    },
    decrementErrors() {
      if (this.errorCount > 0) {
        this.errorCount--
      }
    },
        async loadResult() {
      try {
        this.loading = true

        // Get all results for the game and find the one for this item
        const gameId = this.item.game_id || this.result.league_game_id
        const itemId = this.item.id

        if (gameId && itemId) {
          const res = await ax.get(`/quality/game/${gameId}`)
          const results = res.data

          // Find the result for this specific quality control item
          const existingResult = results.find(r => r.quality_control_item_id === itemId)

          if (existingResult) {
            this.errorCount = existingResult.errors_found || 0
            this.notes = existingResult.notes || ''
            // Update the resultId to the existing result's ID
            this.resultId = existingResult.id
          } else {
            // No existing result found, start with defaults
            this.errorCount = 0
            this.notes = ''
          }
        } else {
          // Fallback to defaults if we can't determine game/item
          this.errorCount = 0
          this.notes = ''
        }
      } catch (err) {
        console.error('Failed to load quality control result:', err)
        // If result doesn't exist, start with defaults
        this.errorCount = 0
        this.notes = ''
      } finally {
        this.loading = false
      }
    },
                async saveResult() {
      if (!this.resultId) return

      try {
        this.saving = true
        await ax.put(`/quality/result/${this.resultId}`, {
          errors_found: this.errorCount,
          notes: this.notes
        })
      } catch (err) {
        console.error('Failed to save quality control result:', err)
        // Optionally show error notification
      } finally {
        this.saving = false
      }
    },
    debouncedSave() {
      // Clear existing timeout
      if (this.saveTimeout) {
        clearTimeout(this.saveTimeout)
      }

      // Set new timeout to save after 1 second of no changes
      this.saveTimeout = setTimeout(() => {
        this.saveResult()
      }, 1000)
    }
  },
  beforeDestroy() {
    // Clear timeout on component destroy
    if (this.saveTimeout) {
      clearTimeout(this.saveTimeout)
    }
  }
}
</script>

<style lang="scss" scoped>
.quality-control-panel {
  height: 100%;
  display: flex;
  flex-direction: column;

  .quality-control-content {
    flex: 1;
    overflow-y: auto;
  }

  .error-count-display {
    min-width: 80px;
    text-align: center;
    padding: 8px 16px;
    background-color: #f5f5f5;
    border-radius: 8px;
    border: 2px solid #e0e0e0;
  }
}
</style>